import type { AIProactivePluginOptions } from '@atlassian/editor-plugin-ai-proactive';

interface Props {
	options: AIProactivePluginOptions;
}

export function aiProactivePluginOptions({ options }: Props): AIProactivePluginOptions {
	// Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIProactiveConfig`.
	return options;
}
